export const tableInitialState = {
  organizations: [],
  fromStorageFacilities: [],
  storageFacilities: [],
  page: 1
}

export const tableReducer = (state, action) => {
  if (action.state) {
    return {
      ...state,
      ...action.state
    }
  } else if (action.page) {
    return {
      ...state,
      page: action.page
    }
  } else if (action.organizations) {
    return {
      ...state,
      organizations: action.organizations,
      storageFacilities: []
    }
  } else if (action.fromStorageFacilities) {
    return {
      ...state,
      fromStorageFacilities: action.fromStorageFacilities
    }
  } else if (action.storageFacilities) {
    return {
      ...state,
      storageFacilities: action.storageFacilities
    }
  }
  return state
}
